export default {
  namespaced: true,
  state: {
    ready: false,
    loggedin: false || (typeof localStorage.lt != "undefined")
  },
  mutations: {
    setReady(state, payload) {
      state.ready = payload;
    },
    setLoggedIn(state, payload) {
      state.loggedin = payload;
    }
  },
}
